
export const imageService = {
    // 错误信息
    uploadFailed: '图片上传失败',
    generateFailed: 'AI图片生成失败',
    editFailed: '图片编辑失败',
    getStatusFailed: '获取生成状态失败',
    getHistoryFailed: '获取生成历史失败',
    deleteRecordFailed: '删除记录失败',
    downloadFailed: '下载失败',
    downloadImageFailed: '下载图片失败',
    
    // 验证信息
    selectImageFile: '请选择图片文件',
    unsupportedFormat: '只支持 JPG、PNG、WebP 格式的图片',
    fileTooLarge: '图片大小不能超过 10MB',
    imageUrlEmpty: '图片URL不能为空',
    
    // 默认文件名
    defaultFilename: 'generated-image.png'
  };
